import * as z from "zod";

import { surrealRecordSchema } from "./surreal-record";

export const propertySchema = surrealRecordSchema.extend({
  name: z.string(),
});

export type Property = z.infer<typeof propertySchema>;
